import React from "react";
import Tooltip from "components/crm/ui/Tooltip";
import { cx } from "components/crm/ui/uiUtils";

const IconButton = ({ icon: Icon, bordered, primary, label, className, ...props }) => (
  <Tooltip label={label}>
    <button
      type="button"
      aria-label={label}
      className={cx(
        "inline-flex size-10 shrink-0 items-center justify-center rounded-lg transition duration-150 active:scale-95 disabled:active:scale-100",
        primary
          ? "bg-primary text-white hover:bg-[#f08c00] active:bg-primary-dark"
          : bordered
            ? "border border-lineStrong bg-white text-ink hover:border-faint hover:bg-gray-50 active:bg-gray-100"
            : "text-ink hover:bg-surfaceMuted active:bg-lineStrong",
        className
      )}
      {...props}
    >
      <Icon size={20} strokeWidth={2} />
    </button>
  </Tooltip>
);

export default IconButton;
